import { Route } from '@angular/router';

export const auraErrorChildRoutes: Route[] = [
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('../pages/not-authorized/not-authorized.component').then((m) => m.AuraNotAuthorizedComponent),
    title: 'Accès non autorisé',
  },
];

export const errorRoutes: Route = {
  path: '',
  data: {
    layout: 'empty',
  },
  children: auraErrorChildRoutes,
};
